import type {
  OrderStatus,
  PaymentMethod,
  TransactionSource,
  TransactionType,
} from "js/pages/Quotas/types";

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  PENDING: "Pendiente",
  PAYMENT_IN_PROGRESS: "Pago en proceso",
  COMPLETED: "Completada",
  FAILED: "Fallida",
  CANCELLED: "Cancelada",
};

export const ORDER_STATUS_COLORS: Record<OrderStatus, string> = {
  COMPLETED: "border-green-300 bg-green-50 text-green-700",
  PAYMENT_IN_PROGRESS: "border-blue-300 bg-blue-50 text-blue-700",
  PENDING: "border-amber-300 bg-amber-50 text-amber-700",
  FAILED: "border-red-300 bg-red-50 text-red-700",
  CANCELLED: "border-gray-300 bg-gray-50 text-gray-700",
};

export const TRANSACTION_TYPE_LABELS: Record<TransactionType, string> = {
  CONSUMPTION: "Consumo",
  PURCHASE: "Compra",
  ADMIN_ADJUSTMENT: "Ajuste administrativo",
  DISTRIBUTION: "Distribución",
};

export const TRANSACTION_SOURCE_LABELS: Record<TransactionSource, string> = {
  CREDIT_REPORT: "Reporte crediticio",
  ADMIN: "Administración",
  SELF_SERVICE: "Autoservicio",
  API: "API",
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  card: "Tarjeta",
  store: "Efectivo (Paynet)",
  bank_account: "Transferencia (SPEI)",
};

export const QUOTE_TYPE_LABELS: Record<string, string> = {
  PF: "Persona Física",
  PM: "Persona Moral",
};

export const formatCurrency = (amount: number) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(amount);
